// extracted by mini-css-extract-plugin
module.exports = {"editVaultFileWindowCommentsBlock":"editVaultFileWindowCommentsBlock__qMiiB"};